import React, { FC } from "react";
import logo from "../../assets/LogoTEALCA.svg";
import classNames from "classnames";
import ShipmentTableSearch from "./ShipmentTableSearch";

const ShipmentSearch: FC = () => {
  const url = new URL(window.location.href);
  const hideLogo = url.searchParams.get("hide-logo");

  return (
    <div className="flex flex-col">
      <div className="flex flex-1 items-center justify-center">
        <img
          src={logo}
          alt="Logo TEALCA"
          className={classNames("h-32 mt-8", hideLogo !== null && "hidden")}
        />
      </div>

      <div className="p-4 shadow-lg rounded-lg mx-2 md:mx-5 mb-8 mt-8 flex flex-col lg:flex-row gap-10 border border-gray-300 bg-white">
        <ShipmentTableSearch />
      </div>
    </div>
  );
};

export default ShipmentSearch;
